import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconDirections = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M21.41 10.69 13.42 2.7a2 2 0 0 0-2.83 0l-8 8a2 2 0 0 0 0 2.83l8 8a2 2 0 0 0 2.82 0l7.99-7.99a2 2 0 0 0 .01-2.85ZM13.5 14.6v-2.5H10v3H8v-4a1 1 0 0 1 1-1h4.5V7.6l3.5 3.5-3.5 3.5Z"
      />
    </Svg>
  );
};
